const logTypes = {
  PERIODIC_SNAPSHOT: "PERIODIC_SNAPSHOT",
  FACE_ABSENCE: "FACE_ABSENCE",
  MULTIPLE_FACE: "MULTIPLE_FACE",
  SOUND_DETECTED: "SOUND_DETECTED",
};

export default logTypes;
